<template>
  <div
    class="card card_white flex-fill justify-content-center"
    v-bind:style="height != null ? 'height: '+ height +'px;' : ''"
  >
    <div
      class="d-flex align-items-center"
      style="justify-content: space-between"
    >
      <div>
        <div class="sub_title_2" v-if="param != null">{{ param.metricName }}</div>
        <div v-if="param != null" style="font-size: 20px; font-weight: 700">{{ formattedNumber(param.value) }}</div>
        <div>{{ param.description }}</div>
        <div>RUPTL: {{ formattedNumber(calculateRuptl(param.value)) }} MW</div>	
      </div>
      <div>
          <img @click="showGraph" style="cursor: pointer;" src="@/assets/images/a/chart_icon.svg" />
      </div>
    </div>
  </div>
</template>
<script>
import IconSvg from "@/components/IconSvg.vue";
import { formattedNumber } from "@/utils/helper";


export default {
  components: {
    IconSvg,
  },
  props: {
    param: {
      type: Object, 
      required: true,
    },
    filter: {
      type: Object, 
      required: true,
    },
    height: {
        type: Number,
        required: false,
    }
  },
  mounted() {
  },
  methods: {
    showGraph() {
      this.$emit("showGraph", this.filter);
    },
    calculateRuptl(value) {
      var d = Math.floor(Math.log10(value))
      var ceilNumber = Math.ceil(value / Math.pow(10, d)) * Math.pow(10, d) 

      return ceilNumber
    },
    formattedNumber
  },
};
</script>
